import React, { useState } from 'react';
import MUIDataTable from 'mui-datatables';
import Checkbox from '@mui/material/Checkbox';

function ArchiveProductMetadataTable({ productMetadata, selectedRows, setSelectedRows, setSelectedProductMetadata }) {

    // Data preparation - extract raw data from metadata
    const data = productMetadata.map((item) => [
        item.university,
        item.sport,
        item.athlete_id,
        item.sku_name,
        item.color,
        item.type,
        item.vendor,
        item.product_metadata_id // Hidden column for reference
    ]);

    const columns = [
        {
            name: "University",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "Sport",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "Athlete ID",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "SKU",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "Color",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "Product Type",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "Vendor",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "ID",
            options: {
                display: false, // Hide this column
                filter: false,
                sort: false,
            }
        },
    ];

    const options = {
        filterType: 'checkbox',
        responsive: 'standard',
        selectableRows: 'multiple',
        selectableRowsHeader: true,
        rowsSelected: selectedRows,
        onRowSelectionChange: (currentRowsSelected, allRowsSelected) => {
            const selected = allRowsSelected.map(row => {
                // Get product_metadata_id from the hidden ID column
                return data[row.dataIndex][7];
            });
            setSelectedRows(allRowsSelected.map(row => row.dataIndex));
            setSelectedProductMetadata(selected)

            // If you need to call your original handleMetadataSelect function
            // selected.forEach(id => handleMetadataSelect(id));
        },
        onSelectAll: (isSelected, rows, selectedRows) => {
            if (isSelected) {
                setSelectedRows(rows.map((row, index) => row));
                // If you need to call your original handleSelectAll function
                // handleSelectAll();
            } else {
                setSelectedRows([]);
            }
            console.log(selectedRows);
        },
        customToolbarSelect: (selectedRows, displayData, setSelectedRows) => {
            return (
                <div className="custom-toolbar">
                    <span>{`${selectedRows.data.length} item(s) selected`}</span>
                    {/* Add your custom action buttons here */}
                </div>
            );
        },
        print: false,
        download: false,
        viewColumns: true,
    };

    return (
        <MUIDataTable
            title={"Product Metadata"}
            data={data}
            columns={columns}
            options={options}
        />
    );
}

export default ArchiveProductMetadataTable;